/**
 * Update an accommodation stay based on another change in stay.
 * Example: if a new stay is extended, calculate wether another existing stay shrinks or disappears altogether.
 * @param {*} newStay
 * @param {*} currStay
 * @returns
 */
export function getUpdatedStay(newStay, currStay) {
    const { checkInDay, nights } = currStay;
    const end = checkInDay + nights;
    const newStayEnd = newStay.checkInDay + newStay.nights;

    let newCheckInDay = checkInDay;
    let newNights = nights;

    if (newStay.checkInDay >= checkInDay && newStay.checkInDay < end) {
        newNights = newStay.checkInDay - checkInDay;
    } else if (newStayEnd > checkInDay && newStayEnd <= end) {
        newCheckInDay = newStayEnd;
        newNights = end - newCheckInDay;
    }

    return {
        checkInDay: newCheckInDay,
        nights: newNights
    };
}

/**
 * Initialize day Ids. Makes it easier
 * to work with the data in the editor.
 */
export function initializeDayId(itinerary) {
    let days = [];
    if (itinerary) {

        let dayIndex = 0;
        if (!itinerary.days) {
            itinerary.days = [];
        }

        for (const day of itinerary.days) {
            day.id = `day-${dayIndex}`;
            days.push(day);
            dayIndex++;
        }

        const endDate = new Date(itinerary.endDate).getTime();
        const startDate = new Date(itinerary.startDate).getTime();
        const n = (endDate - startDate) / (1000 * 60 * 60 * 24) - itinerary.days.length;
        for (let i = 0; i <= n; i++) {
            const emptyDay = { id: `day-${itinerary.days.length + i}`, plans: [] }
            days.push(emptyDay);
        }
    }

    return days;
}

/**
 * Format hours to a readable format.
 */
export const formatHour = (hour) => {
    if (!hour) return '';
    const h = hour.toString();
    if (!h.includes(':')) {
        const formattedH = h.substring(0, 2) + ':' + h.substring(2);
        return formattedH;
    }
    return h;
};

export const checkInvalidSuggestionPlan = (type, previewMode, suggestion) => {
    return type === 'suggestion' && previewMode === 'embed' && !suggestion;
};
